import React from "react";
import './Tasks.scss';
import { startTaskUpdate } from "./taskSlice";
import TasksNode from "../Tasks/TasksNode/TasksNode";
import StartedForm from "./StartedForm";
//import { getResult } from "../Quiz/quizSlice";

const Tasks = (props) => {


   const {dispatch} = props;

// HANDLER ON CLICK START/STOP TASK IN STARTED FORM
const sendStartedFunction = () => {
   // console.log('START');

    const item = {
        taskId: props.tasksData.taskIdForStartedForm,
        started: props.tasksData.startedForStartedForm,
    }  
        
   // console.log(item);
 
    dispatch(startTaskUpdate(item));
}


   // RENDER  STARTED FORM
   const renderStartedForm = () => {
    
   
    if (props.tasksData.openStartedForm) {
        return (
            <div>
                <StartedForm
                dispatch={dispatch}
                openStartedForm={props.tasksData.openStartedForm}
                valueTask = {props.tasksData.valueForStartedForm}
                handleStarted = {sendStartedFunction}
                />
            </div>
        )
     } else return null;
   
   }
//SORT PUBLIS TASK BY PUBLISHER
   const sortPublicTasksByPublisher = (array) => {
    console.log(array);
     let resultArray = [
      /*  {
            publisher:array[0].publisher,
            data:[array[0]],
        }*/
     ];
   // let publisher = array[0].publisher;
   //  console.log(publisher);

     array.forEach(item => {
       const resultSearch = resultArray.findIndex(item2 => item2.publisher === item.publisher);
        const itemData = {
                publisher:item.publisher,
                data:[item]
            }
          //  console.log(resultSearch);
          //  console.log(itemData);
          //  console.log(resultArray);
       if (resultSearch !== -1) {
          resultArray[resultSearch].data.push(item);
           
       } else {
          resultArray.push(itemData);
            
       }
      // console.log(resultArray)
       

     })
     return resultArray;
   }

//RENDER TABLE MAIN TASKS
   const renderMainTasksTable = () => {
        let  tasksPublicInitialAuthState =  props.tasksData.tasksPublic;
        let  tasksPrivateInitialAuthState =  props.tasksData.tasksPrivate;
        //console.log(typeof(data1));
        //console.log(tasksPublicInitialAuthState);
      //<p className="header">{props.element.publisher} </p> 
        const arrayData = (!props.taskMineView) ? tasksPublicInitialAuthState : tasksPrivateInitialAuthState; 


        if (arrayData.length !== 0) {

        const sortedArray = sortPublicTasksByPublisher(arrayData);
       // console.log(sortedArray);

        return (
            
            
            sortedArray.map((item1, index1) => {





                return (


                    <div key={index1}>
                        <p className="header">{item1.publisher}</p>
                    {

                    item1.data.map((item, index) => 
            
            
                    

                <TasksNode
                    key={index}
                    authData={props.authData}
                    element = {item}
                    tasksDataMain={props.tasksDataMain}
                    dispatch={dispatch}
                    tasksData = {props.tasksData}
                    dataNotes = {props.dataNotes}
                    />

                
                
                    )

                    }


                    </div>
                ) 





            })
           
            

           
            )
        } else return null;
       
   }
//RENDER TABLE MAIN TASKS
  /* const renderAssignedTasksTable = () => {
       
      
        const arrayData = props.tasksData.userTasks; 
        if (arrayData.length !== 0) {
        return (
            <div>
            {arrayData.map((item, index) => 
          // return (
           
                

               <TasksNode
                key={index}
               
                element = {item}
                tasksDataMain={props.tasksDataMain}
                dispatch={dispatch}
                tasksData = {props.tasksData}
                dataNotes = {props.dataNotes}
                
                />

            
             //  )
                )
            }

            </div>
            )
        } else return null;
       
   }
   */
   const renderAssignedTasksTable = () => {
       
      
        const arrayData = props.tasksData.userTasks; 
        if (arrayData.length !== 0) {
            const sortedUserArray = sortPublicTasksByPublisher(arrayData);
             console.log(sortedUserArray);
       return (
            
            
            sortedUserArray.map((item1, index1) => {





                return (


                    <div key={index1}>
                        <p className="header">{item1.publisher}</p>
                    {

                    item1.data.map((item, index) => 
            
            
                    

                <TasksNode
                    key={index}
                    authData={props.authData}
                    element = {item}
                    tasksDataMain={props.tasksDataMain}
                    dispatch={dispatch}
                    tasksData = {props.tasksData}
                    dataNotes = {props.dataNotes}
                    />

                
                
                    )

                    }


                    </div>
                ) 





            })
           
            

           
            )
        } else return null;
       
   }
    //RENDER
    const taskView = props.taskView;
    const taskMineView = props.taskMineView;

    if (taskView) {
        return (
            <div className="Tasks">
                <div className="header-task">
                    <p className="main-header">Задачи</p>
                   <p className="status-note">public</p>
                </div>


                    <div className="container">
                        
                        
                            
                           
                           
                            
                               {renderMainTasksTable()} 
                         
                        
                    

                    </div>
            {renderStartedForm()}
            </div>
        );
    } else if (taskMineView) {
        return (
            <div className="Tasks">
                <div className="header-task">
                    <p className="main-header">Задачи</p>
                     {/*<p className="status-note">private</p>*/}
                </div>


                   { (props.authData.modulesName[7].status || (props.authData.userRole[0].role_id === 1)) ? <div className="container">
                        
                        <div className="header-task">
                            <p className="header">Мои задачи </p>
                            <p className="status-note">private</p>
                        </div>

                               {renderMainTasksTable()} 

                    </div> : null}
                    <div className="container">
                        <div className="header-task">
                            <p className="header">Мои назначенные задачи </p>
                            {/*<p className="status-note">private/public</p>*/}
                            
                        </div>
                               {renderAssignedTasksTable()} 

                    </div>
            {renderStartedForm()}
            </div>
        );
    }
    
    
    else return null;
}
export default Tasks;